module.exports = __webpack_public_path__ + "img/banner_icon02.384ed715.jpg";